import React from 'react';
import './Greeting.scss';
import PropTypes from 'prop-types';

const Greeting = ({ dataItems, currentStepName }) => {
  return (
    <div
      className={
        'w-full flex flex-col items-center justify-center text-center mb-6 md:!mb-10 px-2'
      }
    >
      <h3
        className="text-main text-base md:text-2xl"
        dangerouslySetInnerHTML={{
          __html: dataItems[currentStepName].greeting,
        }}
      />

      <p className="text-xs italic max-w-[650px] md:text-sm">
        {dataItems[currentStepName].paragraph}
      </p>
    </div>
  );
};

Greeting.propTypes = {
  dataItems: PropTypes.object.isRequired,
  currentStepName: PropTypes.string.isRequired,
  moduleData: PropTypes.object,
  step: PropTypes.number,
};
export default Greeting;
